import PassState from '../../../../../PassState';

const getPassState = data =>
  (data && data.passState) || PassState.NA;

export default getPassState;